export const formatDuration = (duration: any): string => {
  const hours = Math.floor(duration / 60)
  const minutes = duration % 60

  const hourText = hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : ''
  const minuteText =
    minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''
  return `${hourText} ${minuteText}`.trim()
}